import type { ViewStyle } from 'react-native';
import { lightColors, radius, spacing, type ThemeColors } from './index';

export function profilePalette(colors: ThemeColors) {
  const light = colors.white === lightColors.white;
  return {
    heading: light ? '#203B5D' : '#ADC7F2',
    accent: light ? '#397657' : '#95CBB0',
    surround: light ? '#F8F9FA' : colors.gray100,
    optionSurface: colors.white,
    optionBorder: colors.gray200,
    // Fixed pair: theme-inverted white would darken the selected label.
    selectedSurface: '#2D70DC',
    selectedText: '#FFFFFF',
    link: light ? '#2D70DC' : '#8DB9FF',
    warmSurface: light ? '#FBE7DC' : '#493129',
    warmAccent: light ? '#955239' : '#F3BCA3',
    // 7.6 / D-656 — çıkış gibi geri alınamayan satırlar. Uygulamanın tehlike
    // kırmızısının (#E53935) beyazda 4,5:1'i geçen koyusu.
    danger: light ? '#C62828' : '#FF8A80',
  };
}

export function profileFieldStyle(colors: ThemeColors): ViewStyle {
  return {
    minHeight: 48, minWidth: 0,
    borderWidth: 1, borderColor: colors.gray200, borderRadius: radius.control,
    backgroundColor: colors.white,
    paddingHorizontal: spacing.md, paddingVertical: 12,
  };
}

// Profile-only section geometry; not a global card or navigation redesign.
export function profileSectionStyle(colors: ThemeColors): ViewStyle {
  return {
    marginHorizontal: spacing.md,
    marginTop: spacing.md,
    padding: spacing.md,
    borderWidth: 1,
    borderColor: colors.gray200,
    borderRadius: radius.card,
    backgroundColor: colors.white,
    minWidth: 0,
  };
}
